import { axiosInstance, API_PREFIX, type ApiResponse, type RequestParams } from '@/shared/api';
import type { ApiResponseList } from '@/shared/api/types';
import type {
  AgentGeoZoneBase,
  AgentGeoZoneById,
  AgentGeoZoneCreatePayload,
  AgentGeoZoneUpdatePayload,
  AgentGeoZoneItem,
  AgentGeoZoneItemListParams,
  AgentGeoZonePolygonListItem,
} from '../model/types';

const BASE = `${API_PREFIX.ADMIN_V1}/agent-geo-zone`;

export const getItemList = async (
  params?: AgentGeoZoneItemListParams
): Promise<ApiResponse<AgentGeoZoneItem[]>> => {
  const { data } = await axiosInstance.get<ApiResponse<AgentGeoZoneItem[]>>(`${BASE}/item-list`, { params });
  return data;
};

export const getPolygonList = async (): Promise<ApiResponse<AgentGeoZonePolygonListItem[]>> => {
  const { data } = await axiosInstance.get<ApiResponse<AgentGeoZonePolygonListItem[]>>(`${BASE}/polygon-list`);
  return data;
};

export const getList = async (params?: RequestParams): Promise<ApiResponseList<AgentGeoZoneBase>> => {
  const { data } = await axiosInstance.get<ApiResponseList<AgentGeoZoneBase>>(`${BASE}/index`, { params });
  return data;
};

export const getById = async (id: number): Promise<ApiResponse<AgentGeoZoneById>> => {
  const { data } = await axiosInstance.get<ApiResponse<AgentGeoZoneById>>(`${BASE}/show`, { params: { id } });
  return data;
};

export const create = async (payload: AgentGeoZoneCreatePayload): Promise<ApiResponse<AgentGeoZoneById>> => {
  const { data } = await axiosInstance.post<ApiResponse<AgentGeoZoneById>>(`${BASE}/create`, payload);
  return data;
};

export const update = async (payload: AgentGeoZoneUpdatePayload): Promise<ApiResponse<AgentGeoZoneById>> => {
  const { data } = await axiosInstance.post<ApiResponse<AgentGeoZoneById>>(`${BASE}/update`, payload);
  return data;
};

export const remove = async (id: number): Promise<ApiResponse<null>> => {
  const { data } = await axiosInstance.post<ApiResponse<null>>(`${BASE}/delete`, { id });
  return data;
};
